/* esm.sh - d3-transition@3.0.1/src/selection/index */
import{selection as t}from"d3-selection";import o from"d3-transition/src/selection/interrupt.js";import r from"d3-transition/src/selection/transition.js";t.prototype.interrupt=o;t.prototype.transition=r;
//# sourceMappingURL=index.mjs.map